export default {
      id: "unit-list-humidity-usage",
      viewBox: "0 0 7 10",
      url: __webpack_public_path__ + "img/icons.svg#unit-list-humidity",
      toString: function () {
        return this.url;
      }
    }